export default __webpack_public_path__ + "static/realestate_1-b1b2ce7465cb1dc6f4ccb0f0c9dd9f9c.webp";